import React from "react";
import { InfluencePanel } from "@app/components/AttributeSelector/InfluencePanel";

const AdditionalInformation = ({ className, name, value: propValue, options, important = true }) => {
	const value = Array.isArray(propValue) ? propValue : [propValue];
	const fieldName = `${name}_psa`;

	if (!options.some(({ showAdditionalInformation }) => !!showAdditionalInformation)) return "";

	const additionalInformation = options
		.filter(({ value: optionValue }) => value?.includes(optionValue))
		.filter(({ showAdditionalInformation }) => !!showAdditionalInformation);

	return (
		<>
			{additionalInformation && (
				<div className={className}>
					{additionalInformation.map((entry) => (
						<InfluencePanel name={fieldName} entry={entry} important={important} />
					))}
				</div>
			)}
		</>
	);
};

export default AdditionalInformation;
